import { RemoteAction } from './RemoteAction';
import { ActionMethod } from './Enums';
import VatsAPI from '@/Shared/VatsAPI';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

export interface UrlConfig {
    get: RemoteAction;
    update: RemoteAction;
    add?: RemoteAction;
    delete: RemoteAction;
}

export type UrlOptions = UrlConfig | string;

export type AcceptsPayload<T> = ((url: string, data?: T, config?: AxiosRequestConfig) => AxiosResponse<T>);
export type NoPayload<T> = ((url: string, config?: AxiosRequestConfig) => AxiosResponse<T>);

export function getRequestMethod<P extends AcceptsPayload<any> | NoPayload<any>>(method: ActionMethod): P {
    switch (method) {
        case ActionMethod.GET:
            return VatsAPI.get as any as P;
        case ActionMethod.POST:
            return VatsAPI.post as any as P;
        case ActionMethod.PUT:
            return VatsAPI.put as any as P;
        case ActionMethod.DELETE:
            return VatsAPI.delete as any as P;
        default:
            throw Error(`Unknown HTTP Action ${method}`);
    }
}

export function isUrlConfig(config: UrlOptions): config is UrlConfig {
    if (config && (config as UrlConfig).get) {
        return true;
    }
    return false;
}
